const CHANNEL = "dom-belloni-dashboard-refresh";

export function broadcastDashboardRefresh(): void {
  if (typeof BroadcastChannel !== "undefined") {
    try {
      const bc = new BroadcastChannel(CHANNEL);
      bc.postMessage(1);
      bc.close();
      return;
    } catch {}
  }
  window.dispatchEvent(new CustomEvent("dom-belloni-dashboard-refresh"));
}

export function subscribeDashboardRefresh(handler: () => void): () => void {
  if (typeof BroadcastChannel !== "undefined") {
    try {
      const bc = new BroadcastChannel(CHANNEL);
      bc.onmessage = () => handler();
      return () => bc.close();
    } catch {}
  }
  const fn = () => handler();
  window.addEventListener("dom-belloni-dashboard-refresh", fn);
  return () => window.removeEventListener("dom-belloni-dashboard-refresh", fn);
}
